export default {
  DecisionPrincipal: "Quyết định bổ nhiệm hiệu trưởng/ hiệu phó",
  DecisionHeadAccounting: "Quyết định bổ nhiệm hoặc hợp đồng thuê Kế toán trưởng",
  DecisionHeadAccountingExt: "Quyết định bổ nhiệm",
  DecisionToAssign: "Quyết định giao nhiệm vụ điều hành",
  FeeConfig: "Chính sách phí",
  FeePreferential: "Chính sách phí ưu đãi",
  FeeIncurType: "Đối tượng chịu phí",
  FeeExpirationDate: "Hạn áp dụng cấu hình phí",
  personPaymentInfo: "Tài khoản nhận tiền thanh toán",
  personControl: "Người thực hiện đối soát",
  BackDashbroad: "Về trang Tổng quan",
  ExhibitionArea: "Ảnh chụp khu vực trưng bày hàng hóa và cung cấp dịch vụ",
  ExhibitionAreaForPrivateSchool: "Ảnh chụp khu vực dạy học",
  validateNumber: "Phải là số lớn hơn 0",
  hintTextEmail: "Dùng để nhận các thông báo về chính sách, thông tin giao dịch,...",
  BusinessFeild: "Loại dịch vụ",
  Warehouse: "Ảnh chụp kho hàng hóa hoặc/và khu vực cung cấp công cụ thực hiện dịch vụ",
  Cashier: "Ảnh chụp quầy thanh toán",
  CashierPrivateSchool: "Ảnh chụp khu vực thu tiền",
  visa: "Thị thực hoặc giấy tờ chứng minh được miễn thị thực nhập cảnh",
  workLicense: "Giấy phép lao động",
  effectiveDate: "Ngày cấp",
  IdentityEffectiveDate: "Ngày cấp",
  IdentityExpiredDate: "Ngày hết hạn",
  IdentityUnlimited: "Không thời hạn",
  authorizationletter: "Giấy ủy quyền",
  AuthorizationExpiryDate: "Ngày hết hạn của Giấy ủy quyền",
  appointmentDecision: "Quyết định bổ nhiệm hoặc Hợp đồng lao động",
  AppointmentDecisionExpiryDate: "Ngày hết hạn của Quyết định bổ nhiệm hoặc Hợp đồng lao động",
  nationality: "Quốc tịch",
  schoolarea: "Ảnh chụp từ khu vực dạy học",
  businessaddress: "Ảnh chụp địa điểm kinh doanh",
  licensetooperate: "Giấy phép hoạt động",
  licensegoodsandservice: "Giấy phép hành nghề kinh doanh có điều kiện",
  conditionalbusiness: "Kinh doanh có điều kiện",
  conditionalbusinessLink: "Danh sách ngành nghề kinh doanh có điều kiện",
  orDragDrop: "hoặc kéo thả",
  email: "Email",
  emailRegisterServiceTooltip:
    "Dùng để nhận thông báo về giao dịch, đối soát, chính sách... của JETPAY",
  savesuccess: "Lưu thông tin thành công!",
  notificationBaking1: "Số tiền giao dịch sẽ được chuyển vào tài khoản này.",
  notificationBaking2: "Vui lòng kiểm tra thật kỹ các thông tin.",
  identifyAddress: "Nơi cấp",
  SchoolEstablishmentProfile: "Quyết định thành lập trường",
  budgetcode: "Mã ngân sách",
  publicschool: "Công lập",
  privatschool: "Ngoài công lâp",
  save: "Lưu",
  send: "Duyệt",
  approval: "Duyệt",
  Cancel: "Hủy",
  signuppaymentgateway: "Đơn đăng ký dịch vụ cổng thanh toán",
  businessform: "Hình thức kinh doanh",
  PaymentInfo: "Thông tin tài khoản thanh toán",
  PaymentInfoDes: "Số tiền giao dịch thu được sẽ được chuyển vào tài khoản này",
  BusinessType: "Loại hình",
  Bank: "Ngân hàng",
  BankBranch: "Chi nhánh ngân hàng",
  Branch: "Chi nhánh",
  terms: "Bằng việc chọn hoàn thành bạn xác nhận đã đọc và đồng ý với",
  termslink: "điều khoản sử dụng dịch vụ của JetPay",
  title: "Định danh tài khoản",
  Online: "Online",
  Offline: "Offline",
  Province: "Tỉnh/Thành phố",
  District: "Quận/Huyện",
  Wards: "Phường/Xã",
  Address: "Địa chỉ",
  AddressDetail: "Địa chỉ (Số nhà, thôn/ xóm/ đường phố...)",
  GoverningUnit: "Đơn vị chủ quản",
  RepresentativeName: "Người đại diện",
  identityCard: "Giấy tờ tùy thân",
  ServiceTypeGateway: "Cổng thanh toán",
  ServiceTypeBiling: "Thu hộ, chi hộ",
  enterprise: "Doanh nghiệp",
  householdbusiness: "Hộ kinh doanh",
  personal: "Hộ cá thể",
  service: "Dịch vụ",
  fullname: "Họ và tên",
  position: "Chức vụ",
  DateOfBirth: "Ngày sinh",
  IdCardType: "Loại giấy tờ",
  DocsType: "Loại giấy tờ",
  FrontSide: "Mặt trước",
  BackSide: "Mặt sau",
  PassportPage2: "Trang thứ 2 hộ chiếu",
  CMT: "CMT",
  CMND: "CMND",
  CCCD: "CCCD",
  CCCD_CMT: "CCCD / CC",
  Passport: "Hộ chiếu",
  CMTNo: "Số CMND",
  CCCDNo: "Số CCCD",
  PassportCode: "Số hộ chiếu",
  next: "Tiếp theo",
  back: "Quay lại",
  submit: "Hoàn thành",
  LegalRepresentativeInfo: "Thông tin người đại diện pháp luật",
  RepresentativeInfo: "Thông tin người đại diện",
  AuthorizedPersonInfo: "Thông tin người ủy quyền",
  BusinessRegistry: "Đăng ký kinh doanh",
  BusinessInfo: "Thông tin đăng ký kinh doanh",
  BusinessInfoPaper: "Giấy đăng ký kinh doanh",
  MerchantLicenseInfo: "Giấy đăng ký kinh doanh",
  ProductPolicy: "Chính sách giao hàng, đổi hàng, trả hàng và hoàn tiền",
  ProductPolicyLink: "Link chính sách",
  businessOperations: {
    sourceOfFunds: "Thông tin nguồn tiền",
  },
  Workspace: "Ảnh chụp vị trí làm việc của các nhân viên",
  BusinessAreaVideo: "Video địa điểm kinh doanh",
  ExportLicense: "Hồ sơ, chứng từ chứng minh kinh doanh có hoạt động xuất khẩu hợp lệ",
  BusinessTaxNo: "Mã số đăng ký kinh doanh",
  BusinessTaxCode: "Mã số thuế",
  PhoneNumber: "Số điện thoại",
  AuthorizeDoc: "Văn bản ủy quyền",
  Field: "Ngành nghề kinh doanh",
  SignerIsLegalRepresentative: "Người ký hợp đồng là người đại diện theo pháp luật",
  IsHeadAccounting: "Là kế toán trưởng",
  Name: "Tên đơn vị",
  PaymentOwner: "Chủ tài khoản",
  NumberDayOfPaymentCycle: "Kỳ thanh toán",
  NumberDayOfPayment: "Kỳ thanh toán",
  PaymentNo: "Số tài khoản",
  upload: "hoặc kéo thả tệp để tải ảnh",
  uploadbutton: "Bấm vào đây",
  uploadDes: "Định dạng được hỗ trợ: .jpg, .png, .jpeg .pdf",
  uploadIdentify: "Vui lòng chụp ảnh từ bản chính (rõ nét, không mất góc, dầy đủ nội dung)",
  breadcrumb: {
    title1: "Thông tin đơn vị",
    title2: "Thông tin người đại diện theo pháp luật",
    title3: "Thông tin người ký hợp đồng",
    title4: "Đăng ký dịch vụ",
    title5: "Thông tin bổ sung",
    title6: "Tài khoản ngân hàng",
    title7: "Thông tin người đại diện pháp luật",
    title8: "Thông tin Kế toán trưởng",
    paymentcontrol: "Thanh toán, đối soát",
    feeconfig: "Chính sách phí",
    profileContract: "Thông tin hợp đồng",
  },
  warning: {
    pendingIdentify:
      "Đơn đăng ký của bạn đã được gửi đến JetPay phê duyệt. Kết quả sẽ được thông báo trong 2 giờ làm việc",
    denyIdentify:
      "Hồ sơ định danh của bạn đã bị từ chỗi. Lý do: ####. Vui lòng cập nhật lại hồ sơ định danh.",
    BusinessForm: "Bạn phải chọn ít nhất một hình thức thanh toán",
    InvalidFileNumber: "Bạn chỉ được chọn tối đa ### file",
    InvalidFileSize: "Dung lượng tệp tin không được vượt quá 5MB",
    InvalidFileType: "Định dạng tệp tin không được chấp nhận",
    InvalidFile: "Tệp tin được chọn không hợp lệ",
    GoodIsExist: "Hàng hóa, dịch vụ đã tồn tại.",
  },
  licensenotify: {
    businessInfoPaper:
      "Tải lên Giấy chứng nhận đăng ký doanh nghiệp/hộ kinh doanh hoặc Giấy đăng ký chi nhánh, địa điểm kinh doanh của các chi nhánh<br/>Vui lòng chụp ảnh từ bản chính (rõ nét, không mất góc, đầy đủ nội dung)",
    merchantLicenseInfo:
      "Tải lên Giấy chứng nhận đăng ký doanh nghiệp/hộ kinh doanh hoặc Giấy đăng ký chi nhánh, địa điểm kinh doanh của các chi nhánh<br/>Vui lòng chụp ảnh từ bản chính (rõ nét, không mất góc, đầy đủ nội dung)",
    productPolicy:
      "Định dạng png, jpg, jpeg, pdf <br/>Tải lên ảnh chụp chính sách giao hàng, đổi hàng, trả hàng và hoàn tiền được mô tả trên một trong các kênh sau: <br/>+ Website bán hàng của đơn vị<br/>+ Hợp đồng được ký kết với 1 khách hàng thực tế<br/>+ Tài liệu quy định của đơn vị",
    workspace:
      "Định dạng: png, jpg, jpeg, pdf<br/>Ảnh thấy được quầy lễ tân (nếu có) và nhân viên tại văn phòng làm việc",
    businessAreaVideo:
      "Video đăng tải thuộc định dạng mp4, mov, wmv, avi<br/>Video thể hiện được địa điểm kinh doanh từ bên ngoài, thấy được địa chỉ, bảng hiệu, mặt tiền,...; quầy thanh toán, quầy lễ tân; khu vực trưng bày hàng hóa/cung cấp dịch vụ; kho hàng hóa, dụng cụ; khu vực làm việc",
    exportLicense:
      "Định dạng png, jpg, jpeg, pdf <br/>Ảnh chụp chứng từ chứng minh hoạt động nhập khẩu, như: tờ khai hải quan, hóa đơn thương mại, vận đơn,... của một lô hàng nhập khẩu phát sinh trong 12 tháng gần đây",
    operatinglicense:
      "Tải lên Giấy chứng nhận đăng ký doanh nghiệp/hộ kinh doanh hoặc Giấy đăng ký chi nhánh, địa điểm kinh doanh của các chi nhánh",
    licensetooperate:
      " Tải lên Giấy chứng nhận đăng ký doanh nghiệp/ hộ kinh doanh hoặc Giấy đăng ký chi nhánh, địa điểm kinh doanh của các chi nhánh và Giấy phép ngành nghề kinh doanh có điều kiện",
    businessaddress:
      "Ảnh chụp địa điểm kinh doanh từ bên ngoài: thấy được bảng hiệu (nếu có), địa chỉ, mặt tiền của cửa hàng kinh doanh",
    businessaddressForPrivateSchool:
      "Ảnh chụp trường học từ bên ngoài, thấy được bảng hiệu (nếu có), địa chỉ, mặt tiền của trường học",
    schoolarea: " Ảnh chụp từ cửa phòng, thấy được toàn cảnh khu vực dạy học",
    cashier:
      "Ảnh thấy được nơi thanh toán nhìn từ cửa vào, thấy máy tính tiền (nếu có) hoặc máy POS bán hàng (nếu có) hoặc/và két đựng tiền (nếu có)",
    cashierForPrivateSchool:
      "Ảnh thấy được nơi thu tiền nhìn từ cửa vào, thấy được két đựng tiền (nếu có)",
    warehouse:
      "Ảnh thấy được hình ảnh các hàng hóa hoặc nguyên vật liệu các hàng hóa, hoặc hình ảnh khu vực phục vụ khách hàng thể hiện rõ mặt hàng/dịch vụ đang cung cấp",
    exhibitionarea:
      "Ảnh thấy được hình ảnh các hàng hóa hoặc nguyên vật liệu để chế biến ra các hàng hóa, hoặc hình ảnh khu vực phục vụ khách hàng thể hiện rõ mặt hàng/dịch vụ đang cung cấp",
    exhibitionareaForPrivateSchool:
      "Ảnh chụp trong phòng, thấy được bảng, bàn ghế,... trang thiết bị dạy học",
  },
  toastSuccess:
    "Chúc mừng bạn đăng ký thành công tài khoản kinh doanh. JetPay sẽ kiểm tra hồ sơ để phản hồi trong 2 giờ làm việc và gửi kết quả qua email bạn đã cung cấp",
  IdentifySuccess:
    "Hồ sơ của bạn đã được phê duyệt. Bạn sẽ được chuyển đến trang đăng nhập để tiếp tục sử dụng chương trình",
  LicenseFiles: "licenseFiles",
  IdentifyId: "identifyId",
  ExtractInformation: "Đang trích xuất thông tin ...",
  registryservice: {
    addgood: "Thêm tên hàng hóa, dịch vụ",
    pressEnter: "Ấn Enter để thêm",
    textrevenue: "Tỷ đồng",
    revenue: "Doanh thu",
    regisreydomain: "Đăng ký dịch vụ kết nối Cổng thanh toán với website",
    domainname: "Tên miền",
    logo: "Logo",
    licensebuydomain: "Chứng nhận sở hữu/hóa đơn mua tên miền website",
    listgoodandservice: "Loại hàng hóa, dịch vụ kinh doanh",
    averagerevenue: "Doanh thu trung bình 2 năm gần đây",
    websiteImage: "Ảnh chụp website",
    websiteImageInstruction:
      "Định dạng: png, jpg, jpeg, pdf <br/>Ảnh chụp website thể hiện được tên miền và sản phẩm/dịch vụ cung cấp cho khách hàng",
    websiteInfo: "Để tích hợp cổng thanh toán, website phải đăng ký với Bộ Công Thương",
  },
  merchanttype: {
    type: "Chọn lĩnh vực",
    school: "Trường học",
    other: "Khác",
  },
  Message: {
    ExhibitionArea: "Khu vực trưng bày không được để trống",
    SchoolEstablishmentProfile: "Quyết định thành lập trường không được để trống",
    MerchantLicense: "Giấy phép hoạt động không được để trống",
    VAPartnerNotApprove: "Đối tác VA chưa được duyệt. Không thể gửi hồ sơ cho GSVH",
    BusinessArea: "Địa điểm kinh doanh không được để trống",
    TeachingArea: "Ảnh chụp khu vực dạy học không được để trống",
    Cashier: "Quầy thanh toán không được để trống",
    Warehouse: "Kho hàng hóa không được để trống",
    BusinessConditionLicense: "Giấy phép kinh doanh có điều kiện không được để trống",
    Visa: "Thị thực không được để trống",
    SCVisa: "Thị thực người ủy quyền không được để trống",
    AuthorizationDocs: "Văn bản ủy quyền không được để trống",
    WebsiteCert: "Chứng nhận sở huy tên miền website không được để trống",
    UploadMaxSize: "Kích thước file không được vượt quá {0}MB.",
    UploadMaxFile: "Tối đa tải lên xxx file",
    FailUpload: "Có lỗi xảy ra. Yêu cầu của Quý khách vẫn chưa được gửi. Vui lòng thực hiện lại.",
    Revenue: "Doanh thu và Doanh thu phải lớn hơn 0",
    OrganizationCodeExist: "Mã số thuế đã được đăng ký",
    SchoolCodeExit: "Mã ngân sách đã được đăng ký",
    DomainIsNull: "Tên miền không được để trống",
    LicenseBuyDomainIsNull: "Chứng nhận sở hữu/hóa đơn mua tên miền website không được để trống",
    CheckFeeConfigMonitor:
      "Chính sách phí chỉ được áp dụng khi giám đốc phê duyệt. Bạn có muốn áp dụng không?",
    CheckFeeConfigSaleManager:
      "Chính sách phí chỉ được áp dụng khi quản lý bán hàng phê duyệt. Bạn có muốn áp dụng không?",
    DayOfPaymentCycle: "Kỳ thanh toán không được để trống",
    DayOfPaymentCycleLargerZero: "Kỳ thanh toán phải lớn hơn 0",
  },

  msgFileNull: "Vui lòng tải lên ảnh {0}",
  msgImgNull: "Vui lòng tải lên {0}",
  msgRequired: "Không được để trống {0}",
  PaperIdentify: "cccd/cc/hộ chiếu",
  Visa: "Thị thực",
  emailHint: "Dùng để nhận thông báo về giao dịch, đối soát, chính sách... của JETPAY",
  fileMessage: "Đăng tải tối đa {0} file </br>Định dạng: png, jpg, jpeg, pdf </br> {1}",
  fileMessageNoLimitFile: "Định dạng: png, jpg, jpeg, pdf </br> {1}",
  fileXlxs: "Đăng tải tối đa {0} file </br> Định dạng file: xlxs, pdf </br>",
  sendsuccess: "Hồ sơ đã được gửi lên giám sát vận hành",
  sendSuccessLegislation: "Hồ sơ đã được gửi lên pháp chế",
  NotRequire: "nếu có",
  NotChooseRiskReason: "Chọn ít nhất một lý do cho merchant rủi ro cao",
  FinancialReportNotNull: "Báo cáo tài chính không được để trống",
  action: {
    edit: "Sửa",
    view: "Xem",
    delete: "Xóa",
  },
  EmployeeInCharge: {
    Title: "Nhân viên phụ trách",
    SaleJETPAY: "Nhân viên kinh doanh JETPAY",
    OfficeSaleMisa: "Văn phòng kinh doanh MISA",
    GroupSaleMisa: "Phòng/Nhóm kinh doanh MISA",
  },
};
